(function () {
  function swiperInit() {
    const defaultGallerySections = Array.from(
      document.querySelectorAll('.main-product[data-default-gallery-slide]')
    );

    subSliderInit(true);
    sliderInit(true);
    popupSliderInit(true);

    defaultGallerySections.forEach((section) => {
      section.removeAttribute('data-default-gallery-slide');
    });
  }

  document.addEventListener("shopify:section:load", function (e) {
    swiperInit();
  });

  swiperInit();
})();
